/** Códigos de erro do planejamento de mão de obra (Fases 7 e 8). */
export const PLANNING_ERROR = {
  PLAN_NOT_FOUND: 'PLANNING.PLAN_NOT_FOUND',
  PLAN_CLOSED: 'PLANNING.PLAN_CLOSED',
  PLAN_INVALID_TRANSITION: 'PLANNING.PLAN_INVALID_TRANSITION',

  ALLOCATION_NOT_FOUND: 'PLANNING.ALLOCATION_NOT_FOUND',
  ALLOCATION_HOURS_NOT_POSITIVE: 'PLANNING.ALLOCATION_HOURS_NOT_POSITIVE',
  ALLOCATION_HOURS_GRANULARITY: 'PLANNING.ALLOCATION_HOURS_GRANULARITY',
  ALLOCATION_HOURS_TOO_LARGE: 'PLANNING.ALLOCATION_HOURS_TOO_LARGE',
  ALLOCATION_DATE_OUT_OF_WEEK: 'PLANNING.ALLOCATION_DATE_OUT_OF_WEEK',

  CAPACITY_EXCEEDED: 'PLANNING.CAPACITY_EXCEEDED',
  CAPACITY_OVERRIDE_FORBIDDEN: 'PLANNING.CAPACITY_OVERRIDE_FORBIDDEN',
  CAPACITY_OVERRIDE_NEEDS_REASON: 'PLANNING.CAPACITY_OVERRIDE_NEEDS_REASON',

  RESOURCE_NOT_FOUND: 'PLANNING.RESOURCE_NOT_FOUND',
  RESOURCE_INACTIVE: 'PLANNING.RESOURCE_INACTIVE',
  RESOURCE_WRONG_PROJECT: 'PLANNING.RESOURCE_WRONG_PROJECT',
  ACTIVITY_NOT_FOUND: 'PLANNING.ACTIVITY_NOT_FOUND',
  ACTIVITY_WRONG_PROJECT: 'PLANNING.ACTIVITY_WRONG_PROJECT',
  ACTIVITY_CLOSED: 'PLANNING.ACTIVITY_CLOSED',
  DISCIPLINE_INACTIVE: 'PLANNING.DISCIPLINE_INACTIVE',
  SERVICE_NOT_FOUND: 'PLANNING.SERVICE_NOT_FOUND',
  SERVICE_INACTIVE: 'PLANNING.SERVICE_INACTIVE',
  SERVICE_WRONG_DISCIPLINE: 'PLANNING.SERVICE_WRONG_DISCIPLINE',

  VERSION_CONFLICT: 'PLANNING.VERSION_CONFLICT',
  INSPECTION_NOT_FOUND: 'PLANNING.INSPECTION_NOT_FOUND',
  INSPECTION_IN_FUTURE: 'PLANNING.INSPECTION_IN_FUTURE',
  INSPECTION_CLOSED: 'PLANNING.INSPECTION_CLOSED',
  INSPECTION_ALREADY_OPEN: 'PLANNING.INSPECTION_ALREADY_OPEN',
  ABSENCE_REASON_REQUIRED: 'PLANNING.ABSENCE_REASON_REQUIRED',
  JUSTIFICATION_TOO_SHORT: 'PLANNING.JUSTIFICATION_TOO_SHORT',
  JUSTIFICATION_TOO_LONG: 'PLANNING.JUSTIFICATION_TOO_LONG',
  QUANTITY_WITHOUT_UNIT: 'PLANNING.QUANTITY_WITHOUT_UNIT',
  QUANTITY_INVALID: 'PLANNING.QUANTITY_INVALID',
  QUANTITY_TOO_LARGE: 'PLANNING.QUANTITY_TOO_LARGE',

  // ── Relatório Diário de Obra (Fase 18) ─────────────────────────────────────
  REPORT_NOT_FOUND: 'PLANNING.REPORT_NOT_FOUND',
  REPORT_IN_FUTURE: 'PLANNING.REPORT_IN_FUTURE',
  REPORT_ALREADY_CLOSED: 'PLANNING.REPORT_ALREADY_CLOSED',
  REPORT_NOT_CLOSED: 'PLANNING.REPORT_NOT_CLOSED',
  REPORT_NUMBER_INVALID: 'PLANNING.REPORT_NUMBER_INVALID',
  SHIFT_DUPLICATED: 'PLANNING.SHIFT_DUPLICATED',
  SHIFT_TIME_INCOMPLETE: 'PLANNING.SHIFT_TIME_INCOMPLETE',
  SHIFT_TIME_INVALID: 'PLANNING.SHIFT_TIME_INVALID',
  SHIFT_TIME_NOT_ORDERED: 'PLANNING.SHIFT_TIME_NOT_ORDERED',
  SHIFT_BLOCKED_WITHOUT_REASON: 'PLANNING.SHIFT_BLOCKED_WITHOUT_REASON',
  TASK_DESCRIPTION_TOO_LONG: 'PLANNING.TASK_DESCRIPTION_TOO_LONG',
  TASK_NOTES_TOO_LONG: 'PLANNING.TASK_NOTES_TOO_LONG',
  TASK_TOO_MANY: 'PLANNING.TASK_TOO_MANY',
  TASK_QUANTITY_INVALID: 'PLANNING.TASK_QUANTITY_INVALID',
  TASK_UNIT_TOO_LONG: 'PLANNING.TASK_UNIT_TOO_LONG',
  TASK_HOURS_INVALID: 'PLANNING.TASK_HOURS_INVALID',
  TASK_WORKERS_INVALID: 'PLANNING.TASK_WORKERS_INVALID',
  REPORTED_WORK_ALREADY_PLANNED: 'PLANNING.REPORTED_WORK_ALREADY_PLANNED',
  REPORTED_WORK_ABSENT: 'PLANNING.REPORTED_WORK_ABSENT',
  REPORTED_WORK_SAME_FRONT: 'PLANNING.REPORTED_WORK_SAME_FRONT',
  REPORTED_WORK_REPLACES_OTHER_DAY: 'PLANNING.REPORTED_WORK_REPLACES_OTHER_DAY',
  REPORT_NOTES_TOO_LONG: 'PLANNING.REPORT_NOTES_TOO_LONG',
  CREW_ROLE_TOO_LONG: 'PLANNING.CREW_ROLE_TOO_LONG',
  CREW_ROLE_DUPLICATED: 'PLANNING.CREW_ROLE_DUPLICATED',
  CREW_QUANTITY_INVALID: 'PLANNING.CREW_QUANTITY_INVALID',
  CREW_TOO_MANY: 'PLANNING.CREW_TOO_MANY',
  EQUIPMENT_DESCRIPTION_TOO_LONG: 'PLANNING.EQUIPMENT_DESCRIPTION_TOO_LONG',
  EQUIPMENT_CODE_TOO_LONG: 'PLANNING.EQUIPMENT_CODE_TOO_LONG',
  EQUIPMENT_QUANTITY_INVALID: 'PLANNING.EQUIPMENT_QUANTITY_INVALID',
  EQUIPMENT_TOO_MANY: 'PLANNING.EQUIPMENT_TOO_MANY',

  // Medir por equipe (Fase 30, RN-405 a RN-407).
  MEASUREMENT_IS_BY_PERSON: 'PLANNING.MEASUREMENT_IS_BY_PERSON',
  QUANTITY_IS_TEAMS: 'PLANNING.QUANTITY_IS_TEAMS',
  TEAM_NOT_IN_FRONT: 'PLANNING.TEAM_NOT_IN_FRONT',
  TEAM_MEASUREMENT_NOT_FOUND: 'PLANNING.TEAM_MEASUREMENT_NOT_FOUND',
  TEAM_MEASUREMENT_HAS_PHOTOS: 'PLANNING.TEAM_MEASUREMENT_HAS_PHOTOS',
  /** A pessoa marcada no lançamento da equipe não está nela naquele dia (RN-421). */
  RESOURCE_NOT_IN_TEAM: 'PLANNING.RESOURCE_NOT_IN_TEAM',

  // Planejar por equipe (Fase 30, etapa 3 — RN-422 a RN-426).
  /** Ninguém da equipe pode ser alocado num dos dias pedidos (RN-423). */
  TEAM_EMPTY_ON_DAY: 'PLANNING.TEAM_EMPTY_ON_DAY',
  /** A equipe desativada não recebe planejamento novo (RN-423). */
  TEAM_INACTIVE: 'PLANNING.TEAM_INACTIVE',
} as const;

export const PLANNING_ERROR_MESSAGE: Readonly<Record<string, string>> = {
  [PLANNING_ERROR.PLAN_NOT_FOUND]: 'Semana de planejamento não encontrada.',
  [PLANNING_ERROR.PLAN_CLOSED]:
    'Esta semana está fechada e é somente leitura. Reabra a semana para alterar o planejamento.',
  [PLANNING_ERROR.PLAN_INVALID_TRANSITION]: 'Esta mudança de situação da semana não é permitida.',

  [PLANNING_ERROR.ALLOCATION_NOT_FOUND]: 'Alocação não encontrada.',
  [PLANNING_ERROR.ALLOCATION_HOURS_NOT_POSITIVE]: 'As horas alocadas devem ser maiores que zero.',
  [PLANNING_ERROR.ALLOCATION_HOURS_GRANULARITY]:
    'As horas alocadas devem ser múltiplas de 15 minutos.',
  [PLANNING_ERROR.ALLOCATION_HOURS_TOO_LARGE]:
    'Uma alocação não pode passar de 24 horas por dia de trabalho.',
  [PLANNING_ERROR.ALLOCATION_DATE_OUT_OF_WEEK]:
    'O dia escolhido não pertence a esta semana de planejamento.',

  [PLANNING_ERROR.CAPACITY_EXCEEDED]: 'A alocação ultrapassa a capacidade do recurso.',
  [PLANNING_ERROR.CAPACITY_OVERRIDE_FORBIDDEN]:
    'Seu perfil não pode alocar acima da capacidade. Reduza as horas ou peça a quem tem a permissão.',
  [PLANNING_ERROR.CAPACITY_OVERRIDE_NEEDS_REASON]:
    'Alocar acima da capacidade exige uma justificativa registrada.',

  [PLANNING_ERROR.RESOURCE_NOT_FOUND]: 'Recurso de execução não encontrado.',
  [PLANNING_ERROR.RESOURCE_INACTIVE]:
    'Este recurso está inativo e não recebe nova alocação. As alocações já existentes permanecem.',
  [PLANNING_ERROR.RESOURCE_WRONG_PROJECT]: 'Este recurso pertence a outra obra.',
  [PLANNING_ERROR.ACTIVITY_NOT_FOUND]: 'Atividade não encontrada.',
  [PLANNING_ERROR.SERVICE_NOT_FOUND]: 'Serviço não encontrado.',
  [PLANNING_ERROR.SERVICE_INACTIVE]:
    'Este serviço está desativado no cadastro e não recebe planejamento novo.',
  [PLANNING_ERROR.SERVICE_WRONG_DISCIPLINE]:
    'O serviço é de outra disciplina — escolha um da disciplina desta frente.',
  [PLANNING_ERROR.ACTIVITY_WRONG_PROJECT]: 'Esta atividade pertence a outra obra.',
  [PLANNING_ERROR.ACTIVITY_CLOSED]:
    'Atividade concluída ou cancelada não recebe alocação de mão de obra.',
  [PLANNING_ERROR.DISCIPLINE_INACTIVE]:
    'A disciplina desta frente está desativada e não recebe planejamento novo. Reative-a em Configurações → Disciplinas.',

  [PLANNING_ERROR.INSPECTION_NOT_FOUND]: 'Conferência não encontrada.',
  [PLANNING_ERROR.INSPECTION_IN_FUTURE]: 'Não se confere um dia que ainda não aconteceu.',
  [PLANNING_ERROR.INSPECTION_CLOSED]: 'Esta conferência já foi encerrada. Reabra antes de alterar.',
  [PLANNING_ERROR.INSPECTION_ALREADY_OPEN]: 'Esta conferência ainda está aberta.',
  [PLANNING_ERROR.ABSENCE_REASON_REQUIRED]: 'Informe o motivo da ausência.',
  [PLANNING_ERROR.JUSTIFICATION_TOO_SHORT]:
    'A justificativa precisa dizer o motivo, com pelo menos 10 caracteres.',
  [PLANNING_ERROR.JUSTIFICATION_TOO_LONG]: 'A justificativa passou do tamanho máximo.',
  [PLANNING_ERROR.QUANTITY_WITHOUT_UNIT]:
    'Esta atividade não tem unidade de medição. Defina a unidade na atividade antes de lançar quantidade.',
  [PLANNING_ERROR.QUANTITY_INVALID]: 'A quantidade deve ser um número igual ou maior que zero.',
  [PLANNING_ERROR.QUANTITY_TOO_LARGE]: 'A quantidade informada está acima do limite aceito.',
  [PLANNING_ERROR.VERSION_CONFLICT]:
    'Este registro foi alterado em outra aba ou janela. Recarregue a semana e refaça a alteração.',

  [PLANNING_ERROR.REPORT_NOT_FOUND]: 'Relatório diário não encontrado.',
  [PLANNING_ERROR.REPORT_IN_FUTURE]: 'Não se relata um dia que ainda não aconteceu.',
  [PLANNING_ERROR.REPORT_ALREADY_CLOSED]:
    'Este relatório já foi emitido. Abra uma revisão antes de alterar.',
  [PLANNING_ERROR.REPORT_NOT_CLOSED]:
    'Este relatório ainda não foi emitido — não há o que revisar.',
  [PLANNING_ERROR.REPORT_NUMBER_INVALID]: 'O número do relatório precisa ser inteiro e positivo.',
  [PLANNING_ERROR.SHIFT_DUPLICATED]: 'O mesmo turno foi informado duas vezes.',
  [PLANNING_ERROR.SHIFT_TIME_INCOMPLETE]:
    'Informe a hora de início e a de término do turno, ou deixe as duas em branco.',
  [PLANNING_ERROR.SHIFT_TIME_INVALID]: 'A hora do turno deve estar no formato HH:MM.',
  [PLANNING_ERROR.SHIFT_TIME_NOT_ORDERED]:
    'O término do turno deve ser depois do início. Trabalho depois da meia-noite entra no relatório do dia seguinte.',
  [PLANNING_ERROR.SHIFT_BLOCKED_WITHOUT_REASON]:
    'Informe a condição do tempo que impediu o trabalho neste turno.',
  [PLANNING_ERROR.TASK_DESCRIPTION_TOO_LONG]:
    'A descrição da tarefa passou do tamanho máximo. Escreva o serviço, não o relato.',
  [PLANNING_ERROR.TASK_NOTES_TOO_LONG]: 'A observação da tarefa passou do tamanho máximo.',
  [PLANNING_ERROR.TASK_TOO_MANY]:
    'São tarefas avulsas demais para um dia. O que é serviço planejado entra pelo cronograma.',
  [PLANNING_ERROR.TASK_QUANTITY_INVALID]:
    'A quantidade da tarefa avulsa precisa ser um número maior ou igual a zero.',
  [PLANNING_ERROR.TASK_UNIT_TOO_LONG]: 'A unidade da tarefa avulsa passou do tamanho máximo.',
  [PLANNING_ERROR.TASK_HOURS_INVALID]:
    'As horas da tarefa avulsa devem ser múltiplas de 15 minutos, entre 15 minutos e 24 horas.',
  [PLANNING_ERROR.TASK_WORKERS_INVALID]:
    'Os responsáveis da tarefa avulsa: até 10 nomes, de até 80 caracteres cada.',
  [PLANNING_ERROR.REPORTED_WORK_ALREADY_PLANNED]:
    'Esta pessoa já tem esta frente neste dia. Ajuste as horas e a medição pela conferência.',
  [PLANNING_ERROR.REPORTED_WORK_ABSENT]:
    'Esta pessoa está registrada como ausente neste dia. Reabra a conferência dela antes de lançar trabalho.',
  [PLANNING_ERROR.REPORTED_WORK_SAME_FRONT]:
    'É a mesma atividade que já está lançada. Escolha a certa — as horas e a quantidade desta se ajustam no dia da pessoa.',
  [PLANNING_ERROR.REPORTED_WORK_REPLACES_OTHER_DAY]:
    'A atividade a trocar é de outra pessoa ou de outro dia. Recarregue a conferência.',
  [PLANNING_ERROR.REPORT_NOTES_TOO_LONG]: 'A observação do dia passou do tamanho máximo.',
  [PLANNING_ERROR.CREW_ROLE_TOO_LONG]: 'O nome da função passou do tamanho máximo.',
  [PLANNING_ERROR.CREW_ROLE_DUPLICATED]:
    'A mesma função foi informada duas vezes. Some as pessoas numa linha só.',
  [PLANNING_ERROR.CREW_QUANTITY_INVALID]:
    'O efetivo de uma função deve ser um número inteiro entre 0 e 999.',
  [PLANNING_ERROR.CREW_TOO_MANY]: 'São funções demais para um dia de obra.',
  [PLANNING_ERROR.EQUIPMENT_DESCRIPTION_TOO_LONG]:
    'A descrição do equipamento passou do tamanho máximo.',
  [PLANNING_ERROR.EQUIPMENT_CODE_TOO_LONG]: 'O código do equipamento passou do tamanho máximo.',
  [PLANNING_ERROR.EQUIPMENT_QUANTITY_INVALID]:
    'A quantidade de um equipamento deve ser um número inteiro entre 1 e 999. Equipamento que não foi usado sai da lista.',
  [PLANNING_ERROR.EQUIPMENT_TOO_MANY]: 'São equipamentos demais para um dia de obra.',
  [PLANNING_ERROR.MEASUREMENT_IS_BY_PERSON]:
    'Esta obra mede por pessoa: a quantidade se lança na medição de cada um.',
  [PLANNING_ERROR.QUANTITY_IS_TEAMS]:
    'Na obra por equipe, a quantidade é da equipe: lance na medição da equipe.',
  [PLANNING_ERROR.TEAM_NOT_IN_FRONT]:
    'Ninguém desta equipe trabalhou nesta frente e serviço neste dia. Aloque a equipe antes de medir.',
  [PLANNING_ERROR.TEAM_MEASUREMENT_NOT_FOUND]: 'Medição da equipe não encontrada.',
  [PLANNING_ERROR.TEAM_MEASUREMENT_HAS_PHOTOS]:
    'A medição da equipe tem fotos. Tire as fotos antes de tirar a medição.',
  [PLANNING_ERROR.RESOURCE_NOT_IN_TEAM]:
    'Esta pessoa não está nesta equipe neste dia. Lance o trabalho dela por pessoa.',
  [PLANNING_ERROR.TEAM_EMPTY_ON_DAY]:
    'A equipe não tem ninguém que possa ser alocado neste dia. Tire o dia ou aloque as pessoas uma a uma.',
  [PLANNING_ERROR.TEAM_INACTIVE]:
    'Esta equipe está desativada e não recebe planejamento novo. Reative a equipe ou aloque as pessoas uma a uma.',
};
